const PersonalPointer = () => {
  return (
    <div className="relative w-49 h-49 rounded-full bg-black bg-opacity-20 flex items-center justify-center">
      <div className="w-37 h-37 rounded-full bg-white relative">
        <svg
          className="w-15 h-auto absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.1883 5.32244C11.1883 7.35922 9.53719 9.01035 7.50042 9.01035C5.46364 9.01035 3.81251 7.35922 3.81251 5.32244C3.81251 3.28567 5.46364 1.63454 7.50042 1.63454C9.53719 1.63454 11.1883 3.28567 11.1883 5.32244ZM9.23156 9.71024C10.9795 9.02006 12.2161 7.31567 12.2161 5.32244C12.2161 2.71804 10.1048 0.606758 7.50042 0.606758C4.89602 0.606758 2.78473 2.71804 2.78473 5.32244C2.78473 7.31573 4.02145 9.02017 5.76944 9.7103C3.29488 10.2506 1.23782 11.9252 0.146484 14.1661L1.07051 14.6161C2.24554 12.2034 4.68659 10.5521 7.50066 10.5521C10.3147 10.5521 12.7558 12.2034 13.9308 14.6161L14.8548 14.1661C13.7634 11.9251 11.7063 10.2505 9.23156 9.71024Z"
            fill="#1D1D1B"
            fillOpacity="0.6"
          />
        </svg>
      </div>
    </div>
  );
};
export default PersonalPointer;
